import { Compatibility, debounce, Platform, T_Platform, viewportChangeListener } from '@cgs/wge';
import { Container } from '@cgs/wge';
import { TRIFECTA_SDK_ADAPTER_TOKEN, TrifectaSDKAdapter } from '../../../sdk/trifecta-sdk.adapter';

export const TRIFECTA_HUD_RESIZE_COMPONENT_TOKEN = Symbol('TRIFECTA_HUD_RESIZE_COMPONENT_TOKEN');

export class TrifectaHudResizeComponent {
  constructor(container: Container) {
    if (Compatibility.IsMobileBrowser) {
      return;
    }

    const trifectaSDKAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN);
    const canvas = container.resolve<Platform>(T_Platform).view.canvas;

    const syncSize = () => {
      trifectaSDKAdapter.setCanvasSize(canvas.offsetWidth, canvas.offsetHeight);
    };

    syncSize();

    const syncSizeDebounce = debounce(syncSize, 100);
    viewportChangeListener.on(() => syncSizeDebounce());
  }
}
